// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => ("static/css/" + chunkId + "." + {"72":"9305e070","689":"a7558cbc","704":"4cff40ed"}[chunkId] + ".chunk.css");